import Accordion from './accordion/script';
import ActivityDetector from './activity-detector/script';
import AnchorLinks from './anchor-links/script';
import HeightMatch from './height-match/script';
import HoverGroup from './hover-group/script';
import ModalTrigger from './modal-trigger/script';
import Parallax from './parallax/script';
import ScrollTracking from './scroll-tracking/script';
import SliderDraggable from './slider-draggable/script';
import TabUnderline from './tab-underline/script';
import TransitionDelay from './trans-delay/script';

export default {
	[Accordion.selector]: Accordion,
	[ActivityDetector.selector]: ActivityDetector,
	[AnchorLinks.selector]: AnchorLinks,
	[HeightMatch.selector]: HeightMatch,
	[HoverGroup.selector]: HoverGroup,
	[ModalTrigger.selector]: ModalTrigger,
	[Parallax.selector]: Parallax,
	[ScrollTracking.selector]: ScrollTracking,
	[SliderDraggable.selector]: SliderDraggable,
	[TabUnderline.selector]: TabUnderline,
	[TransitionDelay.selector]: TransitionDelay
};
